import { z } from "zod";

export const workspaceProfileSchema = z.object({
  name: z.string().min(3, "Nama workspace / toko minimal 3 karakter"),
  slug: z
    .string()
    .min(3, "Slug minimal 3 karakter")
    .regex(
      /^[a-z0-9]+(-[a-z0-9]+)*$/,
      "Slug hanya boleh berisi huruf kecil, angka, dan tanda hubung (-)",
    ),
});

export type WorkspaceProfileFormValues = z.infer<typeof workspaceProfileSchema>;
